class BlockedUsers {
    blockUser(username) {
        app.ajax.post('/services/user/block/', {'username': username}, () => {
            this.userBlocked(username);
        });
    }

    blockUserInSettings(username) {
        app.ajax.post('/services/user/block/', {'username': username}, () => {
            window.location.reload();
        });
    }

    userBlocked(username) {
        jQuery('.block-user-link[data-type="block"]').addClass('hidden');
        jQuery('.block-user-link[data-type="unblock"]').removeClass('hidden');
        window.location = "/blocked?username=" + username;
    }

    unblockUser(username, callback) {
        app.ajax.delete('/services/user/block/', {'username': username}, () => this.userUnblocked(callback));
    }

    userUnblocked(callback) {
        jQuery('.block-user-link[data-type="block"]').removeClass('hidden');
        jQuery('.block-user-link[data-type="unblock"]').addClass('hidden');
        if (typeof callback === "function") {
            callback();
        }
    }
};